// Manual choices belong to a conversation and expire only after inbound activity on another channel.
const choices = new Map();
const prefix = 'comms-reply-channel:';
const choiceKey = (session, userId = '') => `${prefix}${userId}:${session.id}`;
function readChoice(key) {
    if (choices.has(key)) return choices.get(key);
    try { const value = JSON.parse(globalThis.localStorage?.getItem(key) || 'null'); if (value?.channel) choices.set(key, value); } catch { /* private browsing: memory is enough */ }
    return choices.get(key);
}
function removeChoice(key) { choices.delete(key); try { globalThis.localStorage?.removeItem(key); } catch { /* storage is optional */ } }
export const clearReplyChannelChoices = () => {
    choices.clear();
    try { Object.keys(globalThis.localStorage || {}).filter((key) => key.startsWith(prefix)).forEach((key) => globalThis.localStorage.removeItem(key)); } catch { /* storage is optional */ }
};
const normalize = (channel) => channel === 'mms' ? 'sms' : channel;
export function latestReplyActivity(session = {}) {
    const entries = [...(session.raw_message_log || []), ...(session.conversation_log || [])]
        .filter((entry) => entry.channel && ['inbound', 'outbound'].includes(entry.direction))
        .sort((a, b) => new Date(b.received_at || b.sent_at || b.at || b.created_at || 0) - new Date(a.received_at || a.sent_at || a.at || a.created_at || 0));
    const inbound = entries.find((entry) => entry.direction === 'inbound');
    return { latest: ['voice', 'phone', 'call'].includes(entries[0]?.channel) ? entries[0] : inbound || entries[0] || { channel: session.channel }, inbound };
}
export function rememberReplyChannel(session, channel, userId = '') {
    const { inbound } = latestReplyActivity(session);
    const key = choiceKey(session, userId);
    const choice = { channel, inboundChannel: normalize(inbound?.channel) || '' };
    choices.set(key, choice);
    try { globalThis.localStorage?.setItem(key, JSON.stringify(choice)); } catch { /* storage is optional */ }
}
export function selectReplyChannel({ session = {}, available = [], smsBlocked = '', whatsappOpen = false, userId = '' } = {}) {
    const { latest, inbound } = latestReplyActivity(session);
    const key = choiceKey(session, userId);
    const manual = readChoice(key);
    if (manual && inbound && normalize(inbound.channel) !== manual.inboundChannel) removeChoice(key);
    const preferred = readChoice(key)?.channel || normalize(latest.channel);
    const wanted = ['voice', 'phone', 'call'].includes(preferred) ? 'sms' : preferred;
    const usable = (channel) => available.includes(channel) && !(channel === 'sms' && smsBlocked)
        && !(channel === 'whatsapp' && !whatsappOpen);
    if (usable(wanted)) return { channel: wanted, reason: '' };
    if (['voice', 'phone', 'call'].includes(preferred)) return { channel: '', reason: 'The last contact was a call. This number cannot receive texts.' };
    const fallback = ['sms', 'email', 'whatsapp'].find(usable) || '';
    const reason = preferred === 'whatsapp' && !whatsappOpen ? 'WhatsApp needs a template now.'
        : preferred === 'sms' && smsBlocked ? smsBlocked : `${preferred || 'The previous channel'} is unavailable.`;
    const labels = { sms: 'SMS', email: 'Email', whatsapp: 'WhatsApp' };
    return { channel: fallback, reason: `${reason}${fallback ? ` Switched to ${labels[fallback]}.` : ' Choose an available channel.'}` };
}
